import * as React from 'react'
import { CreateInvoiceDetail } from '../InvoiceDetailStore'
import { Table, Checkbox, Input, Button, Popconfirm, Tooltip, Icon } from 'antd'
import { observer } from 'mobx-react-lite'
import { ColumnProps } from 'antd/lib/table'
import { CurrencyInput } from '../../../../../components/CurrencyInput'

interface Props {
  createInvoice: CreateInvoiceDetail
}

interface InvoiceDetailFeeRecored {
  key: number
  feeName: JSX.Element
  amount: JSX.Element
  notes: JSX.Element
  taxable: JSX.Element
  options: JSX.Element
}

export const InvoiceDetailFeeTable = observer((props: Props) => {
  const { createInvoice } = props

  const columns: ColumnProps<InvoiceDetailFeeRecored>[] = [
    {
      title: 'Fee or discount',
      dataIndex: 'feeName',
      key: 'feeName',
    },
    {
      title: 'Amount',
      dataIndex: 'amount',
      key: 'amount',
    },
    {
      title: 'Notes',
      dataIndex: 'notes',
      key: 'notes',
    },
    {
      title: 'Taxable',
      dataIndex: 'taxable',
      key: 'taxable',
      align: 'center',
    },
    {
      title: '',
      dataIndex: 'options',
      key: 'options',
      width: 50,
    },
  ]

  const dataSource: InvoiceDetailFeeRecored[] = createInvoice.fees.map((fee, index) => {
    return {
      key: index,
      feeName: (
        <Input.TextArea
          rows={1}
          placeholder='Add a fee name'
          value={fee.name}
          onChange={(e) => fee.setName(e.target.value)}
        />
      ),
      amount: (
        <CurrencyInput
          className='w-50 gr-currency-input'
          centValue={fee.total}
          onChange={(value) => fee.setTotal(value)}
        />
      ),
      notes: (
        <Input.TextArea
          rows={1}
          value={fee.notes}
          placeholder='Add a note'
          onChange={(e) => fee.setNotes(e.target.value)}
        />
      ),
      taxable: (
        <Checkbox onChange={() => fee.toggleTaxEnabled(!fee.taxEnabled)} checked={fee.taxEnabled} />
      ),
      options: (
        <Popconfirm
          title='Sure to remove this fee?'
          placement='left'
          onConfirm={() => createInvoice.removeFee(index)}
        >
          <Button icon='close' size='small' />
        </Popconfirm>
      ),
    }
  })

  return (
    <Table
      className='no-background-table mt-3 mb-3'
      size='small'
      bordered
      pagination={false}
      columns={columns}
      dataSource={dataSource}
      rowClassName={() => 'background-white'}
      scroll={{ x: true }}
      footer={() => (
        <>
          <span>
            Add fee or discount
            <Tooltip title='Useful for shipping, handling, and discounts'>
              <Icon className='ml-2' type='exclamation-circle' />
            </Tooltip>
          </span>
          <Button
            icon='plus'
            size='small'
            className='ml-2'
            onClick={() => createInvoice.addFee()}
          />
        </>
      )}
    />
  )
})
